import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { array } from "../../../types/_types";
import { string } from "../../../types/_types";

import { PipelineStep } from "../../pipelines/types/PipelineStep";

export const ExportPreset = FirestoreDocument.extend({
	id: string(),
	name: string(1),
	steps: array(PipelineStep),
}).merge(FirestoreLifecycle);
